export const WOUND_TYPES = {
  ASSESSMENT: 'Assessment',
  EVALUATION: 'Evaluation'
}
